import auth from '../auth';
import ApigClientFactory from '../apigClient';

export const SearchService = {

    async query(body) {
        let config = {
            invokeUrl: process.env.RTPS_API_URL,
            region: process.env.AWS_REGION,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };

        await auth.getCredentialsForRole(process.env.RTPS_ROLE_SEARCH)
            .then((credentials) => {
                config.accessKey = credentials.Credentials.AccessKeyId;
                config.secretKey = credentials.Credentials.SecretKey;
                config.sessionToken = credentials.Credentials.SessionToken;
            });

        let client = ApigClientFactory.newClient(config);

        return client.invokeApi({}, '/history-search', 'POST', {}, body);
    },
    async export(body) {
        let config = {
            invokeUrl: process.env.RTPS_API_URL,
            region: process.env.AWS_REGION,
            accessKey: '',
            secretKey: '',
            sessionToken: '',
            apiKey: undefined,
            defaultContentType: 'application/json',
            defaultAcceptType: 'application/json'
        };

        await auth.getCredentialsForRole(process.env.RTPS_ROLE_SEARCH)
            .then((credentials) => {
                config.accessKey = credentials.Credentials.AccessKeyId;
                config.secretKey = credentials.Credentials.SecretKey;
                config.sessionToken = credentials.Credentials.SessionToken;
            });

        let client = ApigClientFactory.newClient(config);
        let additionalParamters = {
            headers: {
                'Accept': 'text/csv'
            }
        };
        return client.invokeApi({}, '/history-search/export', 'POST', additionalParamters, body);
    }
};



// WEBPACK FOOTER //
// ./src/services/rtps/search.service.js